RivalIQ.apps.Registration.module('views', function (views, App, Backbone, Marionette) {
    'use strict';

    const RIVAL_IQ_RIGISTRATION_LOGO_PATH = '/images/logo-with-shadow.png';

    views.UserDetails = Marionette.ItemView.extend({
        getTemplate: function () {
            if (this.model.get('admin_created')) {
                return '#activationUserDetailsTemplate';
            } else {
                return '#registrationUserDetailsTemplate';
            }
        },

        ui: {
            firstName: 'input[name=firstname]',
            lastName: 'input[name=lastname]',
            email: 'input[name=email]',
            companyName: 'input[name=companyname]',
            companyTitle: 'input[name=companytitle]',
            password: 'input[name=password]',
            confirmation: 'input[name=passwordConfirmation]',
            termsAndConditions: 'input[name=termsAndConditions]',
            csrfToken: 'input[name=_csrf]',
            pageError: '.x-page-error',
            fieldError: '.help-block',
            detailsSubmit: '.x-details-submit'
        },
        events: {
            'click @ui.detailsSubmit': 'next',
            'keypress input': 'keypress'
        },
        onShow: function () {
            const me = this;

            if (me.model.get('admin_created')) {
                return me.ui.companyName.focus();
            }

            if (me.ui.firstName.val()) {
                return me.ui.password.focus();
            }

            me.ui.firstName.focus();
        },
        save: function () {
            const me = this;
            const ui = me.ui;
            const model = me.model;
            const state = me.serializeForSave();

            // set the child models with the current form state
            model.set(state, {
                silent: true
            });

            // hide any existing errors
            ui.pageError.hide();
            ui.fieldError.hide();
            me.$('.form-group.has-error').removeClass('has-error');

            if (!model.isValid()) {
                _.forEach(model.validationError, function (field) {
                    const input = $(`input[name="${field}"]`);
                    const formGroup = input.closest('.form-group');
                    formGroup.addClass('has-error');
                    formGroup.find('.help-block').show();
                });

                return false;
            }
            return true;
        },
        keypress: function (e) {
            const me = this;
            if (e.keyCode === 13) {
                return me.next();
            }
            return true;
        },
        serializeForSave: function () {
            const me = this;
            const ui = me.ui;

            // TODO make nicer, use FormValidator
            let isAgency = me.model.get('account').is_agency;
            const checked = me.$('input[name=is_agency]:checked');
            if (!_.exists(isAgency) && checked.length) {
                isAgency = parseInt(checked.val());
            }

            return me.model.get('admin_created') ?
                {
                    first_name: $.trim(ui.firstName.val()),
                    last_name: $.trim(ui.lastName.val()),
                    company_name: $.trim(ui.companyName.val()),
                    company_title: $.trim(ui.companyTitle.val()),
                    password: ui.password.val(),
                    passwordConfirmation: ui.confirmation.val(),
                    csrfToken: ui.csrfToken.val(),
                    terms_and_conditions: me.$('input[name=termsAndConditions]:checked').length ? 'on' : 'off'
                } :
                {
                    first_name: $.trim(ui.firstName.val()),
                    last_name: $.trim(ui.lastName.val()),
                    password: ui.password.val(),
                    passwordConfirmation: ui.confirmation.val(),
                    csrfToken: ui.csrfToken.val(),
                    account: {
                        is_agency: isAgency
                    }
                };
        },
        getNextButtonHashFrag: function () {
            return 'company';
        },
        next: function () {
            const me = this;

            if (me.save()) {
                App.trigger('name-and-password-complete');
                return true;
            }

            return false;
        },

        templateHelpers: function () {
            return RivalIQ.state.plan.get('has_quid_compete_branding') ?
                {
                    logoPath: RivalIQ.state.account.get('appLogoPath'),
                    logoStyle: 'max-width: 250px; width: 100%; margin-bottom: 20px;'
                } :
                {
                    logoPath: RIVAL_IQ_RIGISTRATION_LOGO_PATH,
                    logoStyle: ''
                };
        }

    });
});
